import React from "react";
import Parser from "html-react-parser";
import PropTypes from "prop-types";
import useMediaQuery from "app/hooks/useMediaQuery";
import { isNull } from "lodash";
import "./FeaturesTable.css";

FeaturesTable.propTypes = {
  headers: PropTypes.array,
  rows: PropTypes.array,
  footnote: PropTypes.string,
  featureColumnHeaderBGColor: PropTypes.string,
  featureColumnHeaderFontColor: PropTypes.string,
  featureCellBGColorAccent: PropTypes.string,
  featureCellBGColor: PropTypes.string,
  featureCellFontColor: PropTypes.string,
  columnHeaderBGColor: PropTypes.string,
  columnHeaderFontColor: PropTypes.string,
  cellBGColorAccent: PropTypes.string,
  cellBGColor: PropTypes.string,
  cellFontColor: PropTypes.string,
};

//Ejemplo del Formato del Header, titulo y ancho porcentual de columna
/*headers={[
    {title:"Servicio", columnWidthPct:"50%", columnWidthPhonePct:"40%"},
    {title:"Límite de suma", columnWidthPct:"25%", columnWidthPhonePct:"30"},
    {title:"Eventos", columnWidthPct:"25%", columnWidthPhonePct:"30"}
]}*/

function FeaturesTable({
  headers = [],
  rows = [],
  footnote,
  featureColumnHeaderBGColor = "#001a70",
  featureColumnHeaderFontColor = "#fff",
  featureCellBGColorAccent = "#DCDCDC",
  featureCellBGColor = "#E6E6E6",
  featureCellFontColor = "#222",
  columnHeaderBGColor = "#d7de00",
  columnHeaderFontColor = "#001a70",
  cellBGColorAccent = "#e7ea91",
  cellBGColor = "#ebedb5",
  cellFontColor = "#222222",
  ...props
}) {
  const is4K = useMediaQuery("(min-width: 3840px)");
  const isFullHD = useMediaQuery("(min-width: 1920px)");
  const isMidLaptop = useMediaQuery("(min-width: 1366px)");
  const isIpadLandscape = useMediaQuery("(min-width: 1024px)");
  const isIpadPortrait = useMediaQuery("(min-width: 768px)");
  const isIphoneX = useMediaQuery("(min-width: 375px)");
  const isXSmall = useMediaQuery("(max-width: 374px)");

  const tableHeader = (index) => {
    let cls = {};
    cls.fontFamily = "Montserrat";
    cls.fontWeight = "bold";
    cls.fontStretch = "normal";
    cls.fontStyl = "normal";
    cls.letterSpacing = "normal";
    cls.textAlign = "center";

    if (isXSmall) {
      cls.minHeight = "50px";
      cls.fontSize = "14px";
      cls.lineHeight = 0.57;
    }

    if (isIphoneX) {
      cls.minHeight = "50px";
      cls.fontSize = "13px";
      cls.lineHeight = 0.57;
    }

    if (isIpadPortrait) {
      cls.minHeight = "44px";
      cls.fontSize = "16px";
      cls.lineHeight = 0.81;
    }

    if (isIpadLandscape) {
      cls.minHeight = "48px";
      cls.fontSize = "20px";
      cls.lineHeight = 0.9;
    }

    if (isMidLaptop) {
      cls.height = "61px";
      cls.fontSize = "24px";
      cls.lineHeight = 1;
    }

    if (isFullHD) {
      cls.minHeight = "87px";
      cls.fontSize = "32px";
      cls.lineHeight = 1.13;
    }

    if (is4K) {
      cls.minHeight = "87px";
      cls.fontSize = "32px";
      cls.lineHeight = 1.13;
    }

    if (index === 0) {
      cls.backgroundColor = featureColumnHeaderBGColor;
      cls.color = featureColumnHeaderFontColor;
    } else {
      cls.backgroundColor = columnHeaderBGColor;
      cls.color = columnHeaderFontColor;
      cls.lineHeight = 1.0;
    }
    return cls;
  };

  const textStyle = () => {
    let cls = {};

    cls.fontFamily = "Montserrat";
    cls.fontWeight = 600;
    cls.fontStretch = "normal";
    cls.fontStyl = "normal";
    cls.letterSpacing = "normal";
    cls.textAlign = "left";

    if (isXSmall) {
      cls.padding = "8px";
      cls.fontSize = "12px";
    }

    if (isIphoneX) {
      cls.padding = "12px";
      cls.fontSize = "12px";
    }

    if (isIpadPortrait) {
      cls.padding = "12px 12px 12px 11px";
      cls.minHeight = "43px";
      cls.fontSize = "14px";
    }

    if (isIpadLandscape) {
      cls.padding = "12px 16px 12px 15px";
      cls.minHeight = "46px";
      cls.fontSize = "16px";
    }

    if (isMidLaptop) {
      cls.padding = "16px 21px 16px 20px";
      cls.minHeight = "60px";
      cls.fontSize = "20px";
    }

    if (isFullHD) {
      cls.padding = "27px 30px 20px";
      cls.minHeight = "87px";
      cls.fontSize = "24px";
    }

    if (is4K) {
      cls.padding = "27px 30px 20px";
      cls.minHeight = "87px";
      cls.fontSize = "24px";
    }

    return cls;
  };

  const tableCell = (index, isColumnFeature) => {
    let cls = {};
    cls = textStyle();

    if (isColumnFeature) {
      cls.backgroundColor =
        index % 2 === 0 ? featureCellBGColorAccent : featureCellBGColor;
      cls.color = featureCellFontColor;
      cls.textAlign = "left";
    } else {
      cls.backgroundColor = index % 2 === 0 ? cellBGColorAccent : cellBGColor;
      cls.color = cellFontColor;
      cls.textAlign = "right";
    }
    return cls;
  };

  return (
    <div
      className={
        is4K
          ? "contenedor"
          : isFullHD || isMidLaptop
          ? "ms-5 me-5"
          : isIpadLandscape || isIpadPortrait
          ? "ms-4 me-4"
          : "ms-1 me-1"
      }
    >
      <div>
        <table className="table table-responsive align-middle table-borderless">
          <thead>
            <tr>
              {headers &&
                headers.map((header, index) => {
                  return (
                    <th key={index} width={header.columnWidthPct}>
                      <div
                        className="d-flex justify-content-center align-items-center rounded"
                        style={tableHeader(index)}
                      >
                        {header.title}
                      </div>
                    </th>
                  );
                })}
            </tr>
          </thead>
          <tbody>
            {rows &&
              rows.map((row, index) => (
                <tr key={index}>
                  {Object.values(row).map((field, idx) => (
                    <td key={idx + 1}>
                      {idx + 1 === 1 || idx + 1 === idx + 1 + headers.length ? (
                        <div
                          className="rounded"
                          style={tableCell(index, true)}
                          dangerouslySetInnerHTML={{
                            __html: !isNull(field?.html) ? field?.html : "",
                          }}
                        ></div>
                      ) : (
                        <div
                          className="d-flex justify-content-end align-items-center rounded"
                          style={tableCell(index, false)}
                        >
                          {field}
                        </div>
                      )}
                    </td>
                  ))}
                </tr>
              ))}
          </tbody>
        </table>
        {footnote && <div style={textStyle()}>{Parser(footnote)}</div>}
      </div>
    </div>
  );
}

export default FeaturesTable;
